// extracted by mini-css-extract-plugin
export var container = "_66-0";
export var error = "_66-9";
export var label = "_66-5";
export var light = "_66-6";
export var md = "_66-3";
export var sm = "_66-2";
export var thin = "_66-8";
export var thinBold = "_66-7";
export var vertical = "_66-4";
export var xs = "_66-1";